<template>
  <component :is="el"><slot></slot></component>
</template>

<script>

  import Waypoints from 'waypoints/lib/noframework.waypoints.js'
  import 'waypoints/lib/shortcuts/inview.js'

  export default {
    name: 'inView',
    props: {
      el: {
        type: String,
        default: "div"
      }
    },
    data () {
      return {
        inview: null
      }
    },
    mounted () {
      this.init()
      $(window).on("resize", this.refresh)
    },
    methods: {
      init () {
        this.inview = new Waypoint.Inview({
          element: this.$el,
          enter: (direction) => {
            this.$emit('enter', direction)
          },
          entered: (direction) => {
            this.$emit('entered', direction)
          },
          exit: (direction) => {
            this.$emit('exit', direction)
          },
          exited: (direction) => {
            this.$emit('exited', direction)
          }
        })
      },
      refresh () {
        if(this.inview) {
          this.inview.destroy()
          this.init()
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/_global/in-view.vue